import * as yup from 'yup'

const requiredValueObject = (fieldName) =>
    yup
        .mixed()
        .test(fieldName, `${fieldName} is required`, (val) => {
            if (!val) return false;

            if (typeof val === "string") return val.trim().length > 0;

            if (typeof val === "object" && val.value) {
                return String(val.value).trim().length > 0;
            }

            return false;
        });

export const courseSchema = yup.object().shape({
    courseId: yup.string().nullable(), // optional / generated later
    universityId: requiredValueObject("University"),
    degreeType: requiredValueObject("Degree type"),
    courseNameId: requiredValueObject("Course name"),
    courseCategoryId: requiredValueObject("Course category"),
    // duration_months: yup.string(),
    duration_years: requiredValueObject("Duration in years"),
    // learning_hours: requiredValueObject("Learning hours"),
    languageOfInstruction: yup
        .array()
        .of(
            yup.object().shape({
                label: yup.string().required("Language is required"),
                group: yup.string().nullable(),
            })
        )
        .min(1, "At least one language must be selected"),
    emiFinancialAidForm: yup.object().shape({
        // emiEnabled: yup.string().oneOf(["yes", "no"]).required("EMI enabled flag is required"),
        partnersId: yup.array().of(
            yup.object().shape({
                label: yup.string().required("Partner name is required"),
                value: yup.string().required("Partner ID is required"),
                image: yup.string().url("Invalid partner image URL").nullable(),
            })
        ).when("emiEnabled", {
            is: "yes",
            then: (schema) => schema.min(1, "At least one partner is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        overview: yup.string().when("emiEnabled", {
            is: "yes",
            then: (schema) => schema.required("EMI overview is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // zeroInterest: yup.boolean(),
        tenure: yup.string().when("zeroInterest", {
            is: true,
            then: (schema) => schema.required("Tenure is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
    }),

    scholarshipOpportunitiesAvailable: yup.object().shape({
        // emiEnabled: yup.string().oneOf(["yes", "no"]).required("Scholarship enabled flag is required"),
        eligibility: yup.array().of(yup.string()),
        // .min(1, "Eligibility is required")
        // .when("emiEnabled", {
        //   is: "yes",
        //   then: (schema) => schema.min(1, "At least one eligibility is required"),
        //   otherwise: (schema) => schema.notRequired(),
        // }),
        overview: yup.string().when("emiEnabled", {
            is: "yes",
            then: (schema) => schema.required("Scholarship overview is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
    }),

    outcomesOpportunities: yup
        .array()
        .of(yup.string().required("Outcome/Opportunity is required")),
    // .min(1, "At least one outcome/opportunity is required"),

    faqsQuestions: yup.array().of(
        yup.object().shape({
            question: yup.string().required("Question is required"),
            answer: yup.string().required("Answer is required"),
        })
    ),

    examModeSelector: yup.string().required("Exam mode is required"),

    uploadRelevantDocument: yup.array().of(
        yup.object().shape({
            title: yup.string().nullable(),
            file: yup.mixed().nullable(), // can be null before upload
            uploading: yup.boolean().required(),
            url: yup.string().url("Invalid document URL").required("Attachment is required"),
        })
    ),
});